import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Cost, Report, Settings, VehicleSettings } from '../../model/settings.model';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ParametersService } from '../../service/parameters.service';
import { ToastService } from '../../service/toast.service';
import { RoiService } from '../../service/roi.service';
import { flatten } from 'lodash/array';

@Component({
  selector: 'app-parameters-cost',
  templateUrl: './parameters-cost.component.html',
  styleUrls: ['./parameters-cost.component.less'],
})
export class ParametersCostComponent implements OnInit {


  @Input() vehicle: VehicleSettings;
  @Input() cost: Cost[];
  @Input() report: Report;
  @Input() company: boolean;
  @ViewChild('content') content: ElementRef;
  isOpen: boolean;
  modalRef: NgbModalRef; "other"
  closeResult: string;
  modalOpenValue: Cost;
  index: number;
  locationKeys: string[]
  damagesKeys: string[]
  severityList: any[]
  selectedClass: string;
  selectedClassIndex: number;
  timerEvent: NodeJS.Timer;

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  open(content: any) {
    this.isOpen = true;
    this.modalRef = this.modalService.open(content, { backdropClass: 'backdropClassModal', windowClass: 'parameters-cost-modal' });
    this.modalRef.result.then((result) => {
      this.isOpen = false;
      this.saveCost();
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.isOpen = false;
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  constructor(private modalService: NgbModal,
    private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService,
    private readonly _roiService: RoiService) {
    this.locationKeys = flatten(Object.entries(this._roiService.parts)
      .map(p => {
        return this._roiService
          .getAllLocationPossibleVariants(p[0], p[1]);
      }));

    this.severityList = this._roiService.severityOptionSelect.filter(sev => { return (sev.key !== 'SEV0' && sev.key !== 'SEV5') })
    this.damagesKeys = Object.keys(this._roiService.vehicleDamageTypes).filter(key => {
      return (key !== 'added'
        && key !== 'other'
        && key !== 'missing_part'
        && key !== 'parking_sensor'
        && key !== 'washer_nozzle')
    })
  }

  initCost() {
    this.vehicle.classes.forEach(className => {
      let index = this.cost.findIndex(cost => { return cost.class === className.value })
      if (index !== -1) {
        // Class exist init data inside
        let activeClass = this.cost[index]
        this.locationKeys.forEach(locationKey => {
          let indexLocation = activeClass.location.findIndex(location => { return location.value === locationKey })
          if (indexLocation === -1) {
            // Create location, damage and severity if not exist
            let newLocationData = {
              value: locationKey,
              remplacementCost: undefined,
              price: []
            }
            this.damagesKeys.forEach(damagesKey => {
              let newDamageCost = {
                typeDamage: damagesKey,
                value: []
              }
              this.severityList.forEach(severityData => {
                let newValue = { severity: severityData.key, cost: undefined }
                newDamageCost.value.push(newValue)
              });
              newLocationData.price.push(newDamageCost)
            })
            activeClass.location.push(newLocationData)
          } else {
            let activeLocation = activeClass.location[indexLocation]
            this.damagesKeys.forEach(damagesKey => {
              let indexDamage = activeLocation.price.findIndex(damage => { return damage.typeDamage === damagesKey })
              if (indexDamage === -1) {
                // Create damage and severity if not exist into location
                let newDamageCost = {
                  typeDamage: damagesKey,
                  value: []
                }
                this.severityList.forEach(severityData => {
                  let newValue = { severity: severityData.key, cost: undefined }
                  newDamageCost.value.push(newValue)
                });
                activeLocation.price.push(newDamageCost)
              } else {
                let activeDamage = activeLocation.price[indexDamage]
                this.severityList.forEach(severityData => {
                  let indexSeverity = activeDamage.value.findIndex(data => { return data.severity === severityData.key })
                  if (indexSeverity === -1) {
                    // create severity on dont exist
                    let newValue = { severity: severityData.key, cost: undefined }
                    activeDamage.value.push(newValue)
                  }
                });
              }
            })
          }
        })
      } else {
        // Create a new class inside data
        let newClass: Cost = new Cost
        newClass.class = className.value;
        newClass.location = []
        this.locationKeys.forEach(locationKey => {
          let newLocationData = {
            value: locationKey,
            remplacementCost: undefined,
            price: []
          }
          this.damagesKeys.forEach(damagesKey => {
            let newDamageCost = {
              typeDamage: damagesKey,
              value: []
            }
            this.severityList.forEach(severityData => {
              let newValue = { severity: severityData.key, cost: undefined }
              newDamageCost.value.push(newValue)
            });
            newLocationData.price.push(newDamageCost)
          })
          newClass.location.push(newLocationData)
        })
        console.log(newClass)
        this.cost.push(newClass)
      }
    })
  }

  handlerChangeClassName(event) {
    this.selectedClassIndex = this.cost.findIndex(cost => { return cost.class === event.value })
  }

  openModal() {
    this.initCost();
    this.open(this.content)
  }

  changeAutoCost() {
    this.report.checkDamages = !this.report.checkDamages
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      console.log("report save", this.report);
      this._toastService.toastOpen(true);
      this._parametersService.saveReport(this.report, this.company).then((saved: Settings) => {
        this.report = saved.report;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  savetest(event){
    console.log('aaa', event);
  }

  clearAllUnset() {
    return new Promise((resolve, reject) => {
      this.cost.forEach((classData) => {
        if (classData.location) {
          classData.location.forEach((location) => {
            if (location.price) {
              location.price.forEach((damage) => {
                if (damage.value)
                  damage.value = damage.value.filter(price => { return price.cost !== undefined })
              })
              location.price = location.price.filter(damage => { return damage.value.length > 0 })
            }
          });
          classData.location = classData.location.filter(location => { return (location.price.length > 0 || location.remplacementCost !== undefined) })
          this.cost = this.cost.filter(data => {
            if (data.location) {
              if (data.location.length > 0)
                return true
              else return false
            } else
              return true
          })
        }
      })
      resolve(true)
    })
  }

  saveCost() {
    this._toastService.toastOpen(true);
    this.clearAllUnset().then(() => {
      this._parametersService.saveCost(this.cost, this.company).then(() => {
        this._toastService.toastOpen(false);
      })
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-cost/parameters-cost.component.ts